import { LitElement, html, customElement, property, css, unsafeCSS } from 'lit-element';
// Notwendig:
/*
APP.augmentedReality()

*/

class OcArLoading extends LitElement {

    static get properties() {
        return {
            color1: { type: String },
            color2: { type: String },
            color3: { type: String },
            width: { type: String },
            height: { type: String },
            proximity: { type: String },
            text: { type: String },
            active: {type: Boolean}
        };
    }

    constructor() {
        super();
        this.color1 = '#232B3B';
        this.color2 = '#F4F4F4';
        this.color3 = '#3ADEB1';
        this.width = "60px";
        this.height = "60px";
        this.proximity = "30px";
        this.text = "Augmented Reality is initialising - Please wait.";
        this.active = false;
    }

    createRenderRoot() {
        return this;
    }

    render() {
        return this.active ? html`
            ${this.style()}
                <div class="container">
                    <div class="cube">
                        <div class="side side1"></div>
                        <div class="side side2"></div>
                        <div class="side side3"></div>
                        <div class="side side4"></div>
                        <div class="side side5"></div>
                        <div class="side side6"></div>
                    </div>
                    <div class="textwrap">
                        <!-- <p class="text">Please wait.</p> -->
                        <p class="text">${this.text}</p>
                    </div>
                </div>
        ` : html``;
    }

    updated() {
        // To be sure its infront!
        document.getElementsByTagName("body")[0].append(this);
    }

    // https://codepen.io/magnus16/pen/rbEju
    style() {
        return html`
            <style>
                oc-ar-loading {
                    position: fixed;
                    left: 0px;
                    top: 0px;
                    height: 100vh;
                    width: 100vw;
                    background-color: rgba(255, 255, 255, 0.97);
                    z-index: 2147483647;
                }
                oc-ar-loading .textwrap {
                    margin-top: 50px;
                    word-break: normal;
                    height: 50%;
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;
                }
                oc-ar-loading .container{
                position:absolute;
                left:50%;
                top:40%;
                width: 75%;
                -webkit-transform: translateX(-50%) translateY(-50%);
                        transform: translateX(-50%) translateY(-50%);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                }
                oc-ar-loading .cube{
                height:${unsafeCSS(this.height)};
                width:${unsafeCSS(this.width)};
                -webkit-transform-origin:50% 50%;
                        transform-origin:50% 50%;
                -webkit-transform-style:preserve-3d;
                        transform-style:preserve-3d;
                -webkit-animation:rotate 3s once ease-in-out;
                        animation:rotate 3s infinite ease-in-out;

                }
                oc-ar-loading .side{
                position:absolute;
                display:block;
                height:${unsafeCSS(this.height)};
                width:${unsafeCSS(this.width)};
                }
                oc-ar-loading .side1{
                background: ${unsafeCSS(this.color1)};
                -webkit-transform:translateZ(${unsafeCSS(this.proximity)});
                        transform:translateZ(${unsafeCSS(this.proximity)});
                color: white;
                }
                oc-ar-loading .side2{
                background: ${unsafeCSS(this.color2)};
                -webkit-transform:rotateY(90deg) translateZ(${unsafeCSS(this.proximity)});
                        transform:rotateY(90deg) translateZ(${unsafeCSS(this.proximity)});
                }
                oc-ar-loading .side3{
                background: ${unsafeCSS(this.color1)};
                -webkit-transform:rotateY(180deg) translateZ(${unsafeCSS(this.proximity)});
                        transform:rotateY(180deg) translateZ(${unsafeCSS(this.proximity)});
                }
                oc-ar-loading .side4{
                background: ${unsafeCSS(this.color2)};
                -webkit-transform:rotateY(-90deg) translateZ(${unsafeCSS(this.proximity)});
                        transform:rotateY(-90deg) translateZ(${unsafeCSS(this.proximity)});
                }
                oc-ar-loading .side5{
                background: ${unsafeCSS(this.color3)};
                -webkit-transform:rotateX(90deg) translateZ(${unsafeCSS(this.proximity)});
                        transform:rotateX(90deg) translateZ(${unsafeCSS(this.proximity)});
                }
                oc-ar-loading .side6{
                background: ${unsafeCSS(this.color3)};
                -webkit-transform:rotateX(-90deg) translateZ(${unsafeCSS(this.proximity)});
                        transform:rotateX(-90deg) translateZ(${unsafeCSS(this.proximity)});
                }

                @keyframes rotate{
                0% {
                    transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
                }
                10% {
                    transform: rotateX(90deg);
                }
                20% {
                    transform: rotateX(90deg) rotateZ(-90deg);
                }
                30% {
                    transform: rotateX(90deg) rotateZ(-180deg);
                }
                40% {
                    transform: rotateX(90deg) rotateZ(-270deg);
                }
                50%{
                    transform: rotateX(90deg) rotateZ(-270deg) rotateY(-90deg);
                }
                60% {
                    transform: rotateX(90deg) rotateZ(-270deg) rotateY(-90deg);
                }
                }

                a{
                font-family:helvetica;
                color:#428bca;
                text-align:center;
                display:block;
                }
            </style>
        `
    }
}
customElements.define('oc-ar-loading', OcArLoading);
